import { verifyPortalHeadSession } from "../../shared/portalHeadAuth";
import { confirmPortalLogout } from "../../shared/portalLogoutConfirm";
import { getApiBase, portalApiUrl } from "./portalApiBase";

export const PORTAL_TOKEN_KEY = "naturals_portal_AUTH_TOKEN";
export const PORTAL_USER_ID_KEY = "naturals_portal_userId";
export const PORTAL_EMAIL_KEY = "naturals_portal_email";
export const PORTAL_LOGIN_PATH = "/naturals-portal";

/** Session is HttpOnly cookie — do not read JWT from localStorage. */
export function getPortalToken() {
  return "";
}

export function isPortalAuthenticated() {
  return Boolean(localStorage.getItem(PORTAL_USER_ID_KEY));
}

export function clearPortalSession() {
  localStorage.removeItem(PORTAL_TOKEN_KEY);
  localStorage.removeItem(PORTAL_USER_ID_KEY);
  localStorage.removeItem(PORTAL_EMAIL_KEY);
}

export async function verifyPortalSession() {
  const result = await verifyPortalHeadSession(portalApiUrl("/me"), {
    onStaleStorage: clearPortalSession,
  });
  if (result && result.authenticated && result.data?.userId) {
    localStorage.setItem(PORTAL_USER_ID_KEY, String(result.data.userId));
    if (result.data.email) localStorage.setItem(PORTAL_EMAIL_KEY, result.data.email);
    return true;
  }
  return false;
}

export async function confirmAndLogout() {
  const ok = await confirmPortalLogout({
    title: "Log out of Naturals Portal?",
    description: "Your session will end on this device. You can sign in again anytime.",
    confirmLabel: "Log out",
  });
  if (!ok) return false;
  try {
    await fetch(`${getApiBase()}/logout`, { method: "POST", credentials: "include" });
  } catch {
    /* ignore */
  }
  clearPortalSession();
  window.location.assign(PORTAL_LOGIN_PATH);
  return true;
}
